import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constant";
import LogoutConstant from "../../MainFrame/constants/Constants";
import restClient from "../../MainFrame/action/APIClient";

var CreateNavigationAction = function () {};

CreateNavigationAction.prototype = {
	createNavigation: function (data) {
		var payload = Object.assign({}, data);
		if (payload.type !== 'RIGHT_NAV') {
			delete payload.padding;
			delete payload.background;
		}
		restClient.createNavigation(payload, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error,
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.CREATE_NAVIGATION,
						data: error,
					});
				}
			} else {
				response['status'] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.CREATE_NAVIGATION,
					data: response,
				});
			}
		});
	},
};

export default new CreateNavigationAction();
